import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const KEY = "taskflow.theme.mode";
const ThemeCtx = createContext(null);

function systemDark() {
  return typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
}

export function ThemeProvider({ children }) {
  const [mode, setModeState] = useState(() => {
    const s = localStorage.getItem(KEY);
    return s === "light" || s === "dark" || s === "system" ? s : "system";
  });
  const [sys, setSys] = useState(systemDark());

  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const fn = (e) => setSys(e.matches);
    mq.addEventListener?.("change", fn);
    return () => mq.removeEventListener?.("change", fn);
  }, []);

  const isDark = mode === "dark" || (mode === "system" && sys);

  useEffect(() => {
    document.documentElement.classList.toggle("theme-dark", isDark);
    document.documentElement.classList.toggle("dark", isDark);
  }, [isDark]);

  const setMode = useCallback((m) => { setModeState(m); localStorage.setItem(KEY, m); }, []);
  const value = useMemo(() => ({ mode, isDark, setMode }), [mode, isDark, setMode]);
  return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>;
}

export function useTheme() {
  const v = useContext(ThemeCtx);
  if (!v) throw new Error("useTheme must be used within ThemeProvider");
  return v;
}
